<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="110px" size="mini" :inline="true">
            <el-form-item label="收票日期" prop="dt_sptime" ><div class="txtCss">{{formData.dt_sptime}}</div></el-form-item>
<!--            <el-form-item label="出票人" prop="vc_cpr" required>{{formData.vc_cpr}}</el-form-item>-->
            <el-form-item label="到期日期" prop="dt_dqtime" ><div class="txtCss">{{formData.dt_dqtime}}</div></el-form-item>
            <el-form-item label="出票日期" prop="dt_cptime" ><div class="txtCss">{{formData.dt_cptime}}</div></el-form-item>
            <el-form-item label="签收银行" prop="vc_qshang" ><div class="txtCss">{{formData.vc_qshang}}</div></el-form-item>
            <el-form-item label="汇票编码" prop="vc_hpcode" ><div class="txtCss">{{formData.vc_hpcode}}</div></el-form-item>
            <el-form-item label="子区间" prop="vc_subcode" ><div class="txtCss">{{formData.vc_subcode}}</div></el-form-item>
<!--            <el-form-item label="付款人" prop="vc_fkkhname" required>{{formData.vc_fkkhname}}</el-form-item>-->
<!--            <el-form-item label="承兑行" prop="vc_dfhang" required>{{formData.vc_dfhang}}</el-form-item>-->
            <el-form-item label="收票公司" prop="vc_spgsname" ><div class="txtCss">{{formData.vc_spgsname}}</div></el-form-item>
            <el-form-item label="汇票金额" prop="f_pay" ><div class="txtCss">{{formData.f_pay}}</div></el-form-item>
<!--            <el-form-item label="状态" prop="vc_hpstatus" required>{{formData.vc_hpstatus}}</el-form-item>-->
<!--            <el-form-item label="处理日期" prop="dt_cltime" required>{{formData.dt_cltime}}</el-form-item>-->
<!--            <el-form-item label="票据去向" prop="vc_skkhname" required>{{formData.vc_skkhname}}</el-form-item>-->

            <el-form-item  prop="vc_cl_bankaccount" label="银行账号" required>
                <el-select :disabled="canEdit" style="width: 200px"  @change="changeyhzh" class="marr4" v-model="formData.vc_cl_bankaccount" size="small" filterable placeholder="请选择银行账号">
                    <el-option v-for="item in yhzhList" :key="item.vc_bank_account" :label="item.vc_bank_account" :value="item.vc_bank_account">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="data.type=='tx'?'贴现银行':'托收银行'" prop="vc_cl_bank" required><div class="txtCss">{{formData.vc_cl_bank}}</div></el-form-item>
            <el-form-item  prop="f_clpay_bank" :label="data.type=='tx'?'贴现金额':'托收金额'" required>
                <el-input-number  :disabled="canEdit||data.type=='ts'" :max="formData.f_pay" @change="clpayChange"  class="changeinput" :controls="false" :precision="2" size="mini" v-model="formData.f_clpay_bank" style="width: 200px"></el-input-number>
            </el-form-item>
            <el-form-item label="贴现息支出" prop="f_clcharges_bank" required v-if="data.type=='tx'"><div class="txtCss">{{formData.f_clcharges_bank}}</div></el-form-item>
            <template v-if="data.type=='tx'">
                <el-form-item  prop="f_cllv_bank" label="贴现率" required>
                    <el-input-number v-model="formData.f_cllv_bank" :disabled="canEdit" class="changeinput" :controls="false" size="mini" style="width: 180px"></el-input-number>%
                </el-form-item>
            </template>
            <el-form-item  prop="dt_dztime" :label="data.type=='tx'?'贴现日期':'托收日期'" required>
<!--                <span>{{formData.dt_paytime}}</span>-->
                <el-date-picker :disabled="canEdit" style="width: 200px"
                        v-model="formData.dt_dztime"
                        size="mini"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" >{{$t('button_save')}}</el-button>
<!--                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>-->
            </template>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                startTime:'',
                pickerOptions: {},
                baseerp:'',
                canEdit:false,
                formData:{
                    i_id:'',
                    vc_cpr:'',
                    dt_sptime:'',
                    dt_dqtime:'',
                    dt_cptime:'',
                    vc_qshang:'',
                    vc_hpcode:'',
                    vc_subcode:'',
                    vc_fkkhname:'',
                    i_fkkhid:'',
                    vc_dfhang:'',
                    vc_spgsname:'',
                    i_spgsid:'',
                    f_pay:'',
                    vc_hpstatus:'',
                    dt_cltime:'',
                    vc_skkhname:'',i_skkhid:'',f_clpay_bank:0,i_cl_bank:'',vc_cl_bank:"",dt_dztime:'',
                    vc_cl_bankaccount:'',f_cllv_bank:'',f_clcharges_bank:0,

                },
                gsList:[],
                yhzhList:[],
                khList:[],
                gysList:[],
                dhcdList:[{i_id:2,vc_name:'承兑'},{i_id:3,vc_name:'电汇'}],
                tableHeight:0,
                searchkh:'',
                bzList:[],
                disabled:false,
            }
        },

        watch: {
            data: {
                handler() {
                    if (this.data) {
                        this.formData=JSON.parse(JSON.stringify(this.data)).data;
                        this.formData.dt_dztime=this.getDateYYYYMMddHHMMSS();
                        this.formData.f_clpay_bank=this.formData.f_pay;
                        this.formData.f_clcharges_bank=0;
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.getAccountByGsid();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            // editForm(){
            //     this.canEdit=true
            // },
            saveForm(){
                if(!this.formData.vc_cl_bankaccount||!this.formData.vc_cl_bank||!this.formData.dt_dztime||!this.formData.f_clpay_bank){
                    this.$message.warning('请填写全部信息')
                    return
                }
                if(this.data.type=='tx'&&(!this.formData.f_cllv_bank)){
                    this.$message.warning('请填写全部信息')
                    return
                }
                this.$confirm('保存后不可修改，是否继续',this.$t('tips_prompt'),{
                    // this.$confirm(this.$t('companyManageMD_do_you_want_to_these_pieces_of_data',[typename,tableData.length]),this.$t('tips_prompt'),{
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type:"warning"
                }).then(()=>{
                    this.disabled=true
                    this.discountAcceptanceBill()
                }).catch(()=>{
                    this.$message.info(this.$t('tips_cancel_operation'))
                })
            },
            cancel(){
                this.$emit('close')
            },
            changeyhzh(e){
                // console.log(e,'eeeeebank')
                if(e){
                    let b=this.yhzhList.find(y=>y.vc_bank_account==e)
                    this.formData.i_cl_bank=b.i_bank_id;
                    this.formData.vc_cl_bank=b.vc_bank_name;
                }
            },
            clpayChange(){
                if(this.data.type=='tx'){
                    if(Number(this.formData.f_clpay_bank)>Number(this.formData.f_pay)){
                        this.$set(this.formData,'f_clpay_bank',this.formData.f_pay)
                        // this.formData.f_clpay_bank=this.formData.f_pay
                        this.$forceUpdate()
                    }
                    // console.log(this.formData.f_clpay_bank,'this.formData.f_clpay_bank')

                    this.formData.f_clcharges_bank=this.formData.f_pay-this.formData.f_clpay_bank
                    this.formData.f_clcharges_bank=Math.round(this.formData.f_clcharges_bank*100)/100
                }
            },
            async getAccountByGsid(){
                let param={
                    i_gsid:this.formData.i_spgsid,
                };
                let res=await API.getAccountByGsid(param);
                if ( res.code == 1 ){
                    this.yhzhList=res.data.accountList;


                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_type:'0,2'
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.gsList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async discountAcceptanceBill(){
                let formData=this.formData;
                formData.vc_hpstatus=this.data.type=='tx'?'贴现':'托收';
                formData.f_cllv_bank=this.formData.f_cllv_bank/100
                let param=formData;
                let res=await API.discountAcceptanceBill(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`

            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-between;

    }
    .txtCss{
        display: inline-block;
        width: 240px;
    }
</style>